module.exports = __webpack_public_path__ + "static/media/izlozba (4).2559cfc2.jpg";